import { Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {
  DELETE_PLAN_ACTION,
  RENAME_PLAN_ACTION,
} from "../../../consts/sentryIds";

import { View } from "../../View";
import { palette } from "../../../theme/palette";

const useStyles = makeStyles({
  container: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    padding: "16px",
    marginTop: "10px",
  },
  green: {
    background: palette.btn.greenFill,
    color: palette.typography.white.high,
    border: palette.btn.greenBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.greenFill,
    },
  },
  yellow: {
    background: palette.btn.yellowFill,
    color: palette.typography.black.high,
    border: palette.btn.yelloBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.yellowFill,
    },
  },
  blue: {
    background: palette.btn.blueFill,
    color: palette.typography.white.high,
    border: palette.btn.blueBorder,
    boxShadow: "none",
    "&:hover": {
      background: palette.btn.blueFill,
    },
  },
});

export const EditPlanModalActions = ({ onSave, onDelete, isNameValid }) => {
  const styles = useStyles();

  return (
    <View className={styles.container}>
      <Button
        className={styles.yellow}
        variant={"contained"}
        onClick={onDelete}
        sentryId={DELETE_PLAN_ACTION}
      >
        Delete
      </Button>
      <Button
        className={styles.blue}
        variant={"contained"}
        onClick={onSave}
        sentryId={RENAME_PLAN_ACTION}
        disabled={!isNameValid}
      >
        Save
      </Button>
    </View>
  );
};
